export const ALPHEUS_APP_ID = 'AAE73547';
export const TEXT_NAMESPACE = 'urn:x-cast:alpheus.cast.title';
export const AUTH_NAMESPACE = 'urn:x-cast:alpheus.cast.auth';
